import { Reveal } from "./Reveal";
import { BuyBox } from "./BuyBox";

export const FinalCta = () => (
  <section id="shop" className="py-24 md:py-32 relative overflow-hidden bg-white" data-testid="final-cta-section">
    <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[720px] h-[420px] rounded-full bg-champagne/60 blur-3xl" />
    <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <img
          src="/assets/product-jar.webp"
          alt="ALIVER 24K Gold Hydrogel Eye Masks jar and box"
          className="mx-auto w-56 md:w-72 rounded-[2rem] border border-champagne/70 shadow-[0_32px_80px_rgb(168,134,27,0.14)]"
          data-testid="final-cta-product-image"
        />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-10 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink text-balance">
          Ready to wake up <span className="italic gold-text">refreshed?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-5 text-base md:text-lg text-[#5C5C5C] max-w-xl mx-auto leading-relaxed">
          60 gold hydrogel patches. One calming ritual. Choose a single pack for £19.99 — or subscribe and save.
        </p>
      </Reveal>
      <Reveal delay={0.26}>
        <div className="mt-10 text-left">
          <BuyBox idPrefix="final" align="center" />
        </div>
      </Reveal>
    </div>
  </section>
);
